// React
import React from 'react'
// Google Maps API
import PlacesAutocomplete from 'react-places-autocomplete'

export default class BirthPlace extends React.Component {

	constructor(props) {
		super(props)
		this.state = { address: '' }
	}

	componentWillMount() {
		this.setState({ address: this.props.address })
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.address && !nextProps.address) {
			this.setState({ address: '' })
		}
	}

	handleChange = (address) => {
		this.setState({ address })
		this.props.onLocationChange({ address })
	}

	handleKeyDown = (e) => {
		if (e.which === 9) {
			e.preventDefault()
		}
	}

	render() {
		const inputProps = {
			value: this.state.address,
			onChange: this.handleChange,
			onKeyDown: this.handleKeyDown,
			placeholder: 'Birth place'
		}
		const style = {
			input: {
				display: 'block',
				width: '100%',
				height: '40px',
				marginTop: '10px',
				color: '#333',
				fontFamily: 'Lato',
				fontSize: '20px',
				fontWeight: 300,
				lineHeight: '28px',
				backgroundColor: 'transparent',
				border: 'none',
				borderBottom: '1px solid #cacdd1'
			},
			placeholder: {
				color: '#333'
			},
			autocompleteContainer: {
				position: 'absolute',
				top: '110%',
				width: '100%',
				height: '200px',
				overflow: 'hidden',
				backgroundColor: '#fff',
				border: '#cacdd1 1px solid',
				borderRadius: '5px',
				zIndex: '2147483647'
			},
			autocompleteItem: {
				backgroundColor: 'transparent',
				paddingTop: '2px',
				paddingBottom: '2px',
				paddingLeft: '5px',
				paddingRight: '5px',
				color: '#333',
				fontSize: '20px',
				lineHeight: '30px',
				cursor: 'pointer',
				borderBottom: '#cacdd1 1px solid'
			},
			autocompleteItemActive: {
				color: '#fff',
				backgroundColor: '#333',
				borderRadius: '5px'
			}
		}
		return <PlacesAutocomplete inputProps={inputProps} styles={style} />
	}
}



// WEBPACK FOOTER //
// ./src/Components/Display/BirthPlace.js